// const v3AdUnitsData = {
//   title: 'Advertisement',
//   pattern: 'Leaderboard',
//   src: 'https://cdn.sanity.io/images/nxpteyfv/media-studio/ea938d043a7242969b9c0bc0d1be2047ea6348e4-1700x1133.jpg?q=100&auto=format',
//   module: 'v3AdUnits',
//   moduleColor: 'Secondary',
// };

// const v3AdUnitsData1 = {
//   title: 'Advertisement',
//   pattern: 'Roadblock',
//   src: 'https://cdn.sanity.io/images/nxpteyfv/media-studio/ea938d043a7242969b9c0bc0d1be2047ea6348e4-1700x1133.jpg?q=100&auto=format',
//   module: 'v3AdUnits',
//   moduleColor: 'Secondary',
// };

// const v3AdUnitsData2 = {
//   title: 'Advertisement',
//   pattern: 'RoadblockLarge',
//   src: 'https://cdn.sanity.io/images/nxpteyfv/media-studio/ea938d043a7242969b9c0bc0d1be2047ea6348e4-1700x1133.jpg?q=100&auto=format',
//   module: 'v3AdUnits',
//   moduleColor: 'Secondary',
// };

// const v3AdUnitsData3 = {
//   title: 'Advertisement',
//   pattern: 'Rectangle',
//   src: 'https://cdn.sanity.io/images/nxpteyfv/media-studio/ea938d043a7242969b9c0bc0d1be2047ea6348e4-1700x1133.jpg?q=100&auto=format',
//   module: 'v3AdUnits',
//   moduleColor: 'Primary',
//   dummyText:
//     "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>",
// };

// const v3AdUnitsData4 = {
//   title: 'Advertisement',
//   pattern: 'Skyscraper',
//   src: 'https://cdn.sanity.io/images/nxpteyfv/media-studio/ea938d043a7242969b9c0bc0d1be2047ea6348e4-1700x1133.jpg?q=100&auto=format',
//   module: 'v3AdUnits',
//   moduleColor: 'Primary',
  // dummyText:
  //   "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>",
// };

// const v3AdUnitsData5 = {
//   title: 'Advertisement',
//   pattern: 'Video',
//   src: 'https://www.youtube.com/embed/FbgzVWY2bbQ?si=2BrGJF-iHfMBWNGs',
//   module: 'v3AdUnits',
//   moduleColor: 'Secondary',
// };

// const v3AdUnitsData6 = {
//   title: 'Advertisement',
//   pattern: 'Interscroller',
//   src: 'https://cdn.sanity.io/images/nxpteyfv/media-studio/ea938d043a7242969b9c0bc0d1be2047ea6348e4-1700x1133.jpg?q=100&auto=format',
//   content: {
//     title: 'Reconnect with<br>what matters',
//     summary:
//       'Explore all that Canada has to offer, where wide open spaces and friendly locals can be found from coast to coast. Experience your country like never before—all you need to bring is an open mind.',
//     dealCtaText: 'Unlock Deals',
//     dealCtaUrl: 'https://www.expedia.ca',
//     ctaText: 'See More',
//     ctaUrl: 'https://www.expedia.ca',
//     logo: 'https://mesocp2.euwest01.umbraco.io/media/jbthmu4x/canada-2.png',
//   },
//   module: 'v3AdUnits',
//   moduleColor: 'Secondary',
// };

const v3AdUnitsData = {
  "_type": "adUnit",
  module:"v3adUnit",
  "layout": "Leaderboard",
  "moduleColor": "Primary",
  "title": "Advertisement",
  "cmsMedia": {
    "_key": null,
    "_type": "cmsMedia",
    "mediaType": "Image",
    "image": {
      "_type": "image",
      "asset": {
        "_type": "sanity.imageAsset",
        "_id": "image-62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707-jpg",
        "assetId": "62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c",
        "path": "images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg",
        "url": "https://cdn.sanity.io/images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg"
      },
      "crop": null,
      "hotspot": null
    },
    "altText": null,
    "videoUrl": null,
    "videoCover": null,
    "aspectRatio": "4:3",
    "imageGradient": false,
    "title": null,
    "tag": null,
    "category": null
  },
  "content": null
}
const v3AdUnitsData1 = {
  "_type": "adUnit",
  module:"v3adUnit",
  "layout": "Roadblock",
  "moduleColor": "Secondary",
  "title": "Advertisement",
  "cmsMedia": {
    "_key": null,
    "_type": "cmsMedia",
    "mediaType": "Image",
    "image": {
      "_type": "image",
      "asset": {
        "_type": "sanity.imageAsset",
        "_id": "image-62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707-jpg",
        "assetId": "62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c",
        "path": "images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg",
        "url": "https://cdn.sanity.io/images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg"
      },
      "crop": null,
      "hotspot": null
    },
    "altText": null,
    "videoUrl": null,
    "videoCover": null,
    "aspectRatio": "4:3",
    "imageGradient": false,
    "title": null,
    "tag": null,
    "category": null
  },
  "content": null
}
const v3AdUnitsData2 ={
  "_type": "adUnit",
  module:"v3adUnit",
  "layout": "RoadblockLarge",
  "moduleColor": "Secondary",
  "title": "Advertisement",
  "cmsMedia": {
    "_key": null,
    "_type": "cmsMedia",
    "mediaType": "Image",
    "image": {
      "_type": "image",
      "asset": {
        "_type": "sanity.imageAsset",
        "_id": "image-62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707-jpg",
        "assetId": "62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c",
        "path": "images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg",
        "url": "https://cdn.sanity.io/images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg"
      },
      "crop": null,
      "hotspot": null
    },
    "altText": null,
    "videoUrl": null,
    "videoCover": null,
    "aspectRatio": "4:3",
    "imageGradient": false,
    "title": null,
    "tag": null,
    "category": null
  },
  "content": null
}
const v3AdUnitsData3 ={
  "_type": "adUnit",
  module:"v3adUnit",
  "layout": "Rectangle",
  "moduleColor": "Primary",
  "title": "Advertisement",
  "cmsMedia": {
    "_key": null,
    "_type": "cmsMedia",
    "mediaType": "Image",
    "image": {
      "_type": "image",
      "asset": {
        "_type": "sanity.imageAsset",
        "_id": "image-62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707-jpg",
        "assetId": "62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c",
        "path": "images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg",
        "url": "https://cdn.sanity.io/images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg"
      },
      "crop": null,
      "hotspot": null
    },
    "altText": null,
    "videoUrl": null,
    "videoCover": null,
    "aspectRatio": "4:3",
    "imageGradient": false,
    "title": null,
    "tag": null,
    "category": null
  },
  "content": null
}
const v3AdUnitsData4 ={
  "_type": "adUnit",
  module:"v3adUnit",
  "layout": "Skyscraper",
  "moduleColor": "Primary",
  "title": "Advertisement",
  "cmsMedia": {
    "_key": null,
    "_type": "cmsMedia",
    "mediaType": "Image",
    "image": {
      "_type": "image",
      "asset": {
        "_type": "sanity.imageAsset",
        "_id": "image-62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707-jpg",
        "assetId": "62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c",
        "path": "images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg",
        "url": "https://cdn.sanity.io/images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg"
      },
      "crop": null,
      "hotspot": null
    },
    "altText": null,
    "videoUrl": null,
    "videoCover": null,
    "aspectRatio": "4:3",
    "imageGradient": false,
    "title": null,
    "tag": null,
    "category": null
  },
  "content": null
}
const v3AdUnitsData5 = {
  "_type": "adUnit",
  module:"v3adUnit",
  "layout": "Interscroller",
  "moduleColor": "Primary",
  "title": "Advertisement",
  "cmsMedia": {
    "_key": null,
    "_type": "cmsMedia",
    "mediaType": "Image",
    "image": {
      "_type": "image",
      "asset": {
        "_type": "sanity.imageAsset",
        "_id": "image-62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707-jpg",
        "assetId": "62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c",
        "path": "images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg",
        "url": "https://cdn.sanity.io/images/nxpteyfv/media-studio/62ddbb81bb7f0e82ab5cac4e01bb0094a27e7d9c-2560x1707.jpg"
      },
      "crop": null,
      "hotspot": null
    },
    "altText": null,
    "videoUrl": null,
    "videoCover": null,
    "aspectRatio": "4:3",
    "imageGradient": false,
    "title": null,
    "tag": null,
    "category": null
  },
  "content": {
    "titleRaw": [
      {
        "markDefs": [],
        "children": [
          {
            "marks": [],
            "text": "Reconnect with",
            "_key": "fe1712729c4c0",
            "_type": "span"
          }
        ],
        "_type": "block",
        "style": "normal",
        "_key": "592470060c63"
      },
      {
        "style": "normal",
        "_key": "1cd8caad19a5",
        "markDefs": [],
        "children": [
          {
            "_type": "span",
            "marks": [],
            "text": "what matters",
            "_key": "87233c03fc5a"
          }
        ],
        "_type": "block"
      }
    ],
    "_type": "adUnitContent",
    "summary": "Explore all that Canada has to offer, where wide open spaces and friendly locals can be found from coast to coast. Experience your country like never before—all you need to bring is an open mind.",
    "logo": {
      "_type": "image",
      "asset": {
        "_type": "sanity.imageAsset",
        "_id": "image-06f5c64e35a5641e3734799cd60dee45966e00ff-209x138-png",
        "assetId": "06f5c64e35a5641e3734799cd60dee45966e00ff",
        "path": "images/nxpteyfv/media-studio/06f5c64e35a5641e3734799cd60dee45966e00ff-209x138.png",
        "url": "https://cdn.sanity.io/images/nxpteyfv/media-studio/06f5c64e35a5641e3734799cd60dee45966e00ff-209x138.png"
      },
      "crop": null,
      "hotspot": null
    },
    "dealsCta": {
      "_key": null,
      "ctaText": "Unlock Deals",
      "ctaUrl": "https://www.expedia.ca",
      "openUrlInNewTab": true,
      "icon": null
    },
    "cta": {
      "_key": null,
      "ctaText": "See More",
      "ctaUrl": "https://www.expedia.ca",
      "openUrlInNewTab": true,
      "icon": null
    }
  }
}
const v3AdUnitsData6 = {
  "_type": "adUnit",
  module:"v3adUnit",
  "layout": "Video",
  "moduleColor": "Secondary",
  "title": "Advertisement",
  "cmsMedia": {
    "_key": null,
    "_type": "cmsMedia",
    "mediaType": "Video",
    "image": null,
    "altText": null,
    "videoUrl": "https://mesocp2.euwest01.umbraco.io/media/vtqnccno/bcw_expedia_b-roll_videos_winter-park_colorado_individual_final.mp4",
    "videoCover": null,
    "aspectRatio": "4:3",
    "imageGradient": false,
    "title": "Add Unit Video Url - mp4",
    "tag": null,
    "category": null
  },
  "content": null
}
const v3AdUnitsData7 = {
  "_type": "adUnit",
  module:"v3adUnit",
  "layout": "Video",
  "moduleColor": "Secondary",
  "title": "Advertisement",
  "cmsMedia": {
    "_key": null,
    "_type": "cmsMedia",
    "mediaType": "Video",
    "image": null,
    "altText": null,
    "youtubeId": "P_q3BdrFsLI",
    "videoUrl": null,
    "videoCover": null,
    "aspectRatio": "4:3",
    "imageGradient": false,
    "title": "Add Unit Video Url - Youtube",
    "tag": null,
    "category": null
  },
  "content": null
}
const v3AdUnitsData8 = {
  "_type": "adUnit",
  module:"v3adUnit",
  "layout": "Video",
  "moduleColor": "Secondary",
  "title": "Advertisement",
  "cmsMedia": {
    "_key": null,
    "_type": "cmsMedia",
    "mediaType": "Video",
    "image": null,
    "altText": null,
    "vimeoId": "9011932",
    "videoUrl": null,
    "videoCover": null,
    "aspectRatio": "4:3",
    "imageGradient": false,
    "title": "Add Unit Video Url - vimeo",
    "tag": null,
    "category": null
  },
  "content": null
}

export { v3AdUnitsData, v3AdUnitsData1, v3AdUnitsData2, v3AdUnitsData3, v3AdUnitsData4, v3AdUnitsData5, v3AdUnitsData6 , v3AdUnitsData7 , v3AdUnitsData8 };

export const   dummyText = "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><br><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>"